export var SourceDomain;
(function (SourceDomain) {
    SourceDomain["Ibinder"] = "Ibinder";
    SourceDomain["Binders"] = "Binders";
    SourceDomain["Tenders"] = "Tenders";
    SourceDomain["TenderBids"] = "TenderBids";
    SourceDomain["Bookshelves"] = "Bookshelves";
    SourceDomain["Organizations"] = "Organizations";
})(SourceDomain || (SourceDomain = {}));
//# sourceMappingURL=SourceDomain.js.map